<template>
  <main>
      <LandingPage />

      <AboutMe />

      <TecnologiesStack />

      <ServicesApp />

    <!-- OJO: el router usa /portfolio, así que el id debe ser 'portfolio' -->
      <PortafolioProjects />

        <ContactMe />
  </main>
</template>

<script>
import LandingPage from './LandingPage.vue'
import AboutMe from './AboutMe.vue'
import TecnologiesStack from './TecnologiesStack.vue'
import ServicesApp from './ServicesApp.vue'
import PortafolioProjects from './PortafolioProjects.vue' // <-- FIX: sube un nivel
import ContactMe from './ContactMe.vue' // <-- FIX: sube un nivel

export default {
  name: 'BodyApp',
  components: {
    LandingPage,
    AboutMe,
    TecnologiesStack,
    ServicesApp,
    PortafolioProjects,
    ContactMe,
  },
}
</script>
